import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { InboxEntry } from '../models/inbox-entry.model';

@Injectable({ providedIn: 'root' })
export class InboxService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiBaseUrl}/api/v1/me/inbox`;

  list(): Observable<InboxEntry[]> {
    return this.http.get<InboxEntry[]>(this.apiUrl);
  }

  aufgaben(): Observable<InboxEntry[]> {
    return this.http.get<InboxEntry[]>(`${this.apiUrl}/aufgaben`);
  }

  markRead(id: string): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/${id}/read`, {});
  }

  markDone(id: string): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/${id}/done`, {});
  }

  markAllRead(): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/read-all`, {});
  }
}
